import useWebsiteApi from "../../hooks/useWebsiteApi";
import { Translations } from "../../types";
import { Units } from "../Dimensions";
import { IShape } from "./ShapeChooser";
import useSWR from "swr";

export const useProduct = (
  productSku: string,
  unit: string,
  templateId?: string
) => {
  const websiteApi = useWebsiteApi();

  const { data: product } = useSWR<{
    sku: string;
    materials: { sku: string; translations: Translations["Materials"] }[];
    shapes: IShape[];
    minDimensions: { unit: Units; width: number; height: number };
    maxDimensions: { unit: Units; width: number; height: number };
    defaultDimensions: { unit: Units; width: number; height: number };
  }>(`/v1/product/${productSku}?u=${unit}`, websiteApi.fetcher);

  const { data: template } = useSWR(
    templateId ? `/api/template?code=${templateId}` : null,
    (s: string) => {
      return fetch(`https://graphic.stickerit.co${s}`).then((resp) =>
        resp.json()
      );
    }
  );

  if (templateId) {
    if (!template) {
      return null;
    }

    return {
      ...product,
      defaultDimensions: {
        width: template.dimensions.width,
        height: template.dimensions.height,
        unit: template.dimensions.unit_type.unit_type_id,
      },
    };
  }

  return product;
};
